import React from 'react';
import UserNavbar from './layout/user-navbar';

let okImg = require('../../img/ic-check.svg');

const ConnectStripeSuccess = () =>
(
    <div className="cover connect-stripes-pg">
        <UserNavbar />
        <div className="container">

            <div className="row">
                <div className="col-md-12">

                    <img className = "center-block img-responsive"
                        src        = {okImg}
                        alt        = "Stripe connection failed"/>

                    <h1 className="text-center">
                        We have successfully connected to your Stripe account.
                    </h1>

                </div>

                <div className="col-md-12 text-center">
                    <button type="submit" className="btn-submit-cta">Ok</button>
                </div>

            </div>
        </div>
    </div>
);

export default ConnectStripeSuccess;



// WEBPACK FOOTER //
// src/components/connect-stripe-success.js